import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from "react";

import { analytics } from "@/lib/analytics";

interface InspectorContextValue {
  loopId: string | null;
  open: (loopId: string) => void;
  close: () => void;
}

const InspectorContext = createContext<InspectorContextValue | null>(null);

export function InspectorProvider({ children }: { children: ReactNode }) {
  const [loopId, setLoopId] = useState<string | null>(null);
  const open = useCallback((id: string) => {
    analytics.track("loop_inspector_opened", { interface_surface: "inspector" });
    setLoopId(id);
  }, []);
  const close = useCallback(() => setLoopId(null), []);
  const value = useMemo(() => ({ loopId, open, close }), [loopId, open, close]);
  return <InspectorContext.Provider value={value}>{children}</InspectorContext.Provider>;
}

export function useInspector(): InspectorContextValue {
  const ctx = useContext(InspectorContext);
  if (!ctx) throw new Error("useInspector must be used inside InspectorProvider");
  return ctx;
}
